// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__1mdes","box":"WorkspacesBox_box__V3j-w","node":"WorkspacesBox_node__1u6Ti"};